<template lang="html">
  <md-table v-once style="width:100%;" @select="selectUser" ref="myTable" v-if="modificar && selection">
    <md-table-header>
      <md-table-row>
        <md-table-head v-for="(row, index) in rows" :key="index">{{row.tittle}}</md-table-head>
        <md-table-head v-if="details">Areas</md-table-head>
        <md-table-head v-if="facturar">Facturar</md-table-head>
        <md-table-head v-if="attachment">Descargar PDF</md-table-head>
        <md-table-head v-if="editButton">Editar</md-table-head>
      </md-table-row>
    </md-table-header>

    <md-table-body>
      <md-table-row v-if="dta.nombre" v-for="(dta, index) in data" :key="index" v-bind="dta" :md-item="dta" md-auto-select md-selection>
        <md-table-cell v-for="(row, indx) in rows" :key="indx">{{getProp(dta, row.prop)}}</md-table-cell>
        <md-table-cell v-if="editButton">
          <md-button class="md-icon-button md-dense" @click="selectEdit(dta)">
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table-body>
  </md-table>

    <md-table style="width:100%;" ref="myTable" v-else>
      <md-table-header>
        <md-table-row>
          <md-table-head v-for="(row, index) in rows" :key="index">{{row.tittle}}</md-table-head>
          <md-table-head v-if="details">Areas</md-table-head>
          <md-table-head v-if="facturar">Facturar</md-table-head>
          <md-table-head v-if="listoFacturar">Listo p/facturar</md-table-head>
          <md-table-head v-if="anticipo">Anticipo</md-table-head>
          <md-table-head v-if="attachment">Descargar PDF</md-table-head>
          <md-table-head v-if="editButton"></md-table-head>
          <md-table-head v-if="deleteBtn">Eliminar</md-table-head>
          <md-table-head v-if="ncr"></md-table-head>
        </md-table-row>
      </md-table-header>

      <md-table-body>
        <md-table-row v-if="data.length === 0">
          <md-table-cell :colspan="getColspan()" style="text-align: center;">No se encontraron registros</md-table-cell>
        </md-table-row>
        <template v-for="(dta, index) in data">
          <md-table-row  :key="index" v-bind="dta" :class="pagos ? 'bold' : ''">
            <md-table-cell v-if="!row.type || row.type === 'string'" v-for="(row, indx) in rows" :key="indx">{{getProp(dta, row.prop)}}</md-table-cell>
            <md-table-cell v-if="row.type && row.type === 'date'" v-for="(row, indx) in rows" :key="indx">{{getDate(getProp(dta, row.prop))}}</md-table-cell>
            <md-table-cell v-if="row.type && row.type === 'money'" v-for="(row, indx) in rows" :key="indx">{{getMoney(getProp(dta, row.prop))}}</md-table-cell>
            <md-table-cell v-if="row.type && row.type === 'boolean'" v-for="(row, indx) in rows" :key="indx">{{getBoolean(getProp(dta, row.prop))}}</md-table-cell>
            <md-table-cell v-if="row.type && row.type === 'booleanFact'" v-for="(row, indx) in rows" :key="indx">{{getBooleanFact(getProp(dta, row.prop))}}</md-table-cell>
            <md-table-cell v-if="details">
              <md-button class="md-icon-button md-dense" @click="selectDetail(dta)">
                <md-icon>add_location</md-icon>
              </md-button>
            </md-table-cell>
            <md-table-cell v-if="facturar">
              <md-button class="md-icon-button md-dense" @click="selectFact(dta)" v-if="!dta.factura && dta.listo_facturar">
                <md-icon>description</md-icon>
                <md-tooltip>Facturar</md-tooltip>
              </md-button>
            </md-table-cell>
            <md-table-cell v-if="listoFacturar">
              <md-layout v-if="!dta.factura" md-align="center">
                <!-- <md-checkbox id="listoFacturar" name="listoFacturar" v-if="listoFacturarReady"
                  :v-model="true" class="md-primary" @change="selectListoFact(dta)"></md-checkbox> -->
                <md-switch v-model="dta.listo_facturar" id="my-test0" name="my-test0"  @change="selectListoFact(dta)"></md-switch>
              </md-layout>
            </md-table-cell>
            <md-table-cell v-if="anticipo">
              <md-button class="md-icon-button md-dense" @click="selectFactAnt(dta)" v-if="dta.factura">
                <md-icon>note_add</md-icon>
                <md-tooltip>Agregar anticipo</md-tooltip>
              </md-button>
            </md-table-cell>
            <md-table-cell v-if="attachment">
              <md-button class="md-icon-button md-dense" @click="selectAttachment(dta)">
                <md-icon>attach_file</md-icon>
                <md-tooltip>descargar PDF</md-tooltip>
              </md-button>
            </md-table-cell>
            <md-table-cell v-if="editButton">
              <md-button class="md-icon-button md-dense" @click="selectEdit(dta)">
                <md-icon>remove_red_eye</md-icon>
              </md-button>
            </md-table-cell>
            <md-table-cell v-if="deleteBtn">
              <md-button class="md-icon-button md-dense" @click="selectDelete(dta)">
                <md-icon>delete</md-icon>
                <md-tooltip>Eliminar</md-tooltip>
              </md-button>
            </md-table-cell>
            <md-table-cell v-if="slct">
              <md-button class="md-icon-button md-dense" @click="selectslct(dta)">
                <md-icon>touch_app</md-icon>
              </md-button>
            </md-table-cell>
            <md-table-cell v-if="ncr">
            </md-table-cell>
          </md-table-row>
          <md-table-row v-if="pagos" class="subtitle">
            <md-table-cell  style="text-align: center;"></md-table-cell>
            <md-table-cell style="text-align: center;">Fecha Vencimiento</md-table-cell>
            <md-table-cell style="text-align: center;">Importe</md-table-cell>
            <md-table-cell style="text-align: center;">Fecha Pagado</md-table-cell>
            <md-table-cell style="text-align: center;">Importe Pagado</md-table-cell>
            <md-table-cell colspan="2" style="text-align: center;">Importe Faltante</md-table-cell>
            <md-table-cell style="text-align: center;"></md-table-cell>
            <md-table-cell style="text-align: center;"></md-table-cell>
          </md-table-row>
          <md-table-row v-if="pagos" v-for="pago in dta.pagos" :key="pago.idinterno" :class="parseFloat(pago.importe) < 0 ? 'descuento' : 'secondTable'">
            <md-table-cell style="text-align: center;"></md-table-cell>
            <md-table-cell style="text-align: center;">{{getDate(pago.fecha_vencimiento)}}</md-table-cell>
            <md-table-cell style="text-align: center;" >{{getMoney(pago.importe)}} {{dta.moneda.clave}}</md-table-cell>
            <md-table-cell style="text-align: center;">{{pago.fecha_pagado ? getDate(pago.fecha_pagado) : 'N/A'}}</md-table-cell>
            <md-table-cell style="text-align: center;">{{getMoney(pago.importe_pagado)}} {{dta.moneda.clave}}</md-table-cell>
            <md-table-cell colspan="2" style="text-align: center;">{{getMoney(parseFloat(pago.importe) - parseFloat(pago.importe_pagado ? pago.importe_pagado : 0))}} {{dta.moneda.clave}}</md-table-cell>
            <md-table-cell v-if="dta.factura">
              <md-button class="md-icon-button md-dense" @click="selectPago(pago)" v-if="parseFloat(pago.importe) > parseFloat(pago.importe_pagado) || !pago.importe_pagado">
                <md-icon>payment</md-icon>
                <md-tooltip>
                  Agregar Pago
                </md-tooltip>
              </md-button>
            </md-table-cell>
            <md-table-cell v-if="dta.factura">
              <md-button class="md-icon-button md-dense" @click="selectNcr(dta, pago)" v-if="parseFloat(pago.importe) > parseFloat(pago.importe_pagado) || !pago.importe_pagado">
                <md-icon>local_offer</md-icon>
                <md-tooltip>
                  Aplicar Descuento NCR
                </md-tooltip>
              </md-button>
            </md-table-cell>
            <md-table-cell v-else style="text-align: center;"></md-table-cell>
            <md-tooltip v-if="parseFloat(pago.importe) < 0">
              Descuento
            </md-tooltip>
          </md-table-row>
          <md-table-row v-if="pagos" class="totales">
            <md-table-cell style="text-align: center;"><b></b></md-table-cell>
            <md-table-cell style="text-align: center;"><b>Totales: </b></md-table-cell>
            <md-table-cell style="text-align: center;"><b>{{getMoney(getTotal(dta))}} {{dta.moneda.clave}}</b></md-table-cell>
            <md-table-cell style="text-align: center;"><b></b></md-table-cell>
            <md-table-cell style="text-align: center;"><b>{{getMoney(getTotalPagado(dta))}} {{dta.moneda.clave}}</b></md-table-cell>
            <md-table-cell colspan="2" style="text-align: center;"><b>{{getTotalFaltante(dta)}} {{dta.moneda.clave}}</b></md-table-cell>
            <md-table-cell style="text-align: center;"></md-table-cell>
          </md-table-row>
        </template>
      </md-table-body>
    </md-table>
</template>

<script type="text/javascript">
import {toMoney} from '../../common/functions/helpers'

export default {
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    rows: {
      type: Array,
      default () {
        return [
          {
            tittle: 'Nombre',
            prop: 'nombre'
          },
          {
            tittle: 'Perfil',
            prop: 'perfil.Nombre'
          }
        ]
      }
    },
    selection: {
      type: Boolean,
      default () {
        return true
      }
    },
    alta: {
      type: Boolean,
      default () {
        return false
      }
    },
    modificar: {
      type: Boolean,
      default () {
        return false
      }
    },
    editButton: {
      type: Boolean,
      default () {
        return false
      }
    },
    details: {
      type: Boolean,
      default () {
        return false
      }
    },
    facturar: {
      type: Boolean,
      default () {
        return false
      }
    },
    listoFacturar: {
      type: Boolean,
      default () {
        return false
      }
    },
    attachment: {
      type: Boolean,
      default () {
        return false
      }
    },
    pagos: {
      type: Boolean,
      default () {
        return false
      }
    },
    slct: {
      type: Boolean,
      default () {
        return false
      }
    },
    deleteBtn: {
      type: Boolean,
      default () {
        return false
      }
    },
    ncr: {
      type: Boolean,
      default () {
        return false
      }
    },
    anticipo: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
   data () {
    return {
      listoFacturarReady:false
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    toMoney,
    getProp (dta, prop) {
      const data = prop.split('.')
      let response = dta
      data.forEach(element => {
        response = response[element]
      })
      return response
    },
    getColspan () {
      let col = this.rows.length
      if (this.details) {
        col++
      }
      if (this.facturar) {
        col++
      }
      if (this.listoFacturar) {
        col++
      }
      if (this.attachment) {
        col++
      }
      if (this.editButton) {
        col++
      }
      if (this.deleteBtn) {
        col++
      }
      if (this.ncr) {
        col++
      }
      return col
    },
    getDate (dta) {
      const date = new Date(dta)
      const year = date.getFullYear()
      const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
      return `${day}/${month}/${year}`
    },
    getBoolean (dta) {
      return dta.toString() === '1' || dta === true || dta === 'true' ? 'activo' : 'inactivo'
    },
    getBooleanFact (dta) {
      return dta.toString() === '1' || dta === true || dta === 'true' ? 'Si' : 'No'
    },
    getMoney (dta) {
      if (dta !== null && dta !== 0 && dta !== '0') {
        return toMoney(parseFloat(dta))
      }
      return '$ 0.00'
    },
    getTotal (dta) {
      let pagado = 0
      dta.pagos.forEach((el) => {
        pagado += parseFloat(el.importe ? el.importe : 0)
      })
      return pagado
    },
    getTotalPagado (dta) {
      let pagado = 0
      dta.pagos.forEach((el) => {
        pagado += parseFloat(el.importe_pagado ? el.importe_pagado : 0)
      })
      return pagado
    },
    getTotalFaltante (dta) {
      return this.getMoney(this.getTotal(dta) - this.getTotalPagado(dta))
    },
    selectUser (selected) {
      this.$emit('TABLE_SELECT_USER', selected)
    },
    selectEdit (row) {
      this.$emit('TABLE_EDIT', row)
    },
    selectDelete (row) {
      this.$emit('TABLE_DELETE', row)
    },
    selectDetail (row) {
      this.$emit('TABLE_DETAILS', row)
    },
    selectFact (row) {
      this.$emit('TABLE_FACT', row)
    },
    selectListoFact (row) {
      this.$emit('TABLE_LISTO_FACT', row)
    },
    selectAttachment (row) {
      this.$emit('TABLE_ATTACHMENT', row)
    },
    selectPago (row) {
      this.$emit('TABLE_PAGO', row)
    },
    selectslct (row) {
      this.$emit('TABLE_SELECT', row)
    },
    selectNcr (row, pago) {
      this.$emit('TABLE_NCR', row, pago)
    },
    selectFactAnt (row) {
      this.$emit('TABLE_NCR_FACT', row)
    }
  },
  mounted () {
    this.data.map((el) => {
      if (el.listo_facturar) {
        el.listo_facturar = el.listo_facturar.toString() === '1' || el.listo_facturar === true || el.listo_facturar === 'true'
      } else {
        el.listo_facturar = false
      }
    })
    this.listoFacturarReady = true
  }
}
</script>

<style src="./table.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/shared-components/table/table.vue